import { Fragment, useEffect } from "react";

const Logout = ({logoutId}: any) => {

  useEffect(() => {
    (async () => {
 
      const response = await fetch(
        `/api/authenticate/logout/${logoutId}`,
        {
          credentials: "include",
        }
      );

      const data = await response.json();

      if (data.signOutIFrameUrl) {
        var iframe = document.createElement("iframe");
        iframe.width = "0";
        iframe.height = "0";
        iframe.src = data.signOutIFrameUrl;
        document.getElementById("logout_iframe")?.appendChild(iframe);
      }

    //   if (data.idp === "Microsoft") {
    //     const response = await fetch(
    //       "https://login.microsoftonline.com/common/oauth2/logout",
    //       { mode: "no-cors", credentials: "include" }
    //     );
    //   }

      if (data.postLogoutRedirectUri) {
        window.location.href = data.postLogoutRedirectUri;
      }
    })();
  }, []);

  return (
    <Fragment>
      <div id="logout_iframe"></div>
    </Fragment>
  );
};

export default Logout;
